import axios from 'axios';
import Cookies from 'js-cookie';
import { host } from '../host';

const api = axios.create({
  baseURL: host,
  responseType: 'json',
});

api.interceptors.request.use(request => {
  try {
    const csrf = Cookies.get('csrftoken');
    request.withCredentials = true;

    if (csrf) {
      request.headers.common['X-CSRFToken'] = csrf;
    }

    return request;
  } catch (err) {
    throw new Error(`axios# Problem with request during pre-flight phase: ${err}.`);
  }
});

export default api;
